export default __webpack_public_path__ + "static/media/not-found.2054b2b5.svg";